/** Recherches du métier, reprises sur les pages publiques. */
export const SEO_NICHE_KEYWORDS = [
    'événement',
    'spectacle',
    'sport',
    'concert',
    'festival',
    'conférence',
    'cinéma',
    'ticket',
    'acheter ticket',
    'mon événement',
    'ticket en ligne',
    'réservation sécurisée',
].join(', ');
